import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelUs_international: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
    meta: [
      {
        label: 'Á',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 5,
    label: 'B',
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: '©',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¢',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¢',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: 'Ð',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: 'É',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
  },
  {
    code: 10,
    label: 'G',
  },
  {
    code: 11,
    label: 'H',
  },
  {
    code: 12,
    label: 'I',
    meta: [
      {
        label: 'Í',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: 'Ø',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: 'M',
    meta: [
      {
        label: 'µ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: 'Ñ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
    meta: [
      {
        label: 'Ó',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: 'Ö',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'Q',
    meta: [
      {
        label: 'Ä',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
    meta: [
      {
        label: '®',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '§',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
    meta: [
      {
        label: 'Þ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 24,
    label: 'U',
    meta: [
      {
        label: 'Ú',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 25,
    label: 'V',
  },
  {
    code: 26,
    label: 'W',
    meta: [
      {
        label: 'Å',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
  },
  {
    code: 28,
    label: 'Y',
    meta: [
      {
        label: 'Ü',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'Z',
    meta: [
      {
        label: 'Æ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¡',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¹',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¹',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '²',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '³',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¤',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '£',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '^',
        modifiers: MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¼',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '½',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¾',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '‘',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '’',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¥',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '÷',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: '[',
    meta: [
      {
        label: '{',
        modifiers: MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '«',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: ']',
    meta: [
      {
        label: '}',
        modifiers: MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 49,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¬',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¦',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¦',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: ';',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¶',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '°',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 52,
    label: "' (dead)",
    meta: [
      {
        label: '" (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '" (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '´',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¨',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¨',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '` (dead)',
    meta: [
      {
        label: '~ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: '<',
        modifiers: MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'Ç',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 56,
    label: '/',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¿',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '"',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '^',
  },
  {
    code: 548,
    label: '&',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '_',
  },
  {
    code: 558,
    label: '+',
  },
  {
    code: 559,
    label: '{',
  },
  {
    code: 560,
    label: '}',
  },
  {
    code: 561,
    label: '|',
  },
  {
    code: 563,
    label: ':',
  },
  {
    code: 564,
    label: '" (dead)',
  },
  {
    code: 565,
    label: '~ (dead)',
  },
  {
    code: 566,
    label: '<',
  },
  {
    code: 567,
    label: '>',
  },
  {
    code: 568,
    label: '?',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '"',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '^',
  },
  {
    code: 4644,
    label: '&',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '_',
  },
  {
    code: 4654,
    label: '+',
  },
  {
    code: 4655,
    label: '{',
  },
  {
    code: 4656,
    label: '}',
  },
  {
    code: 4657,
    label: '|',
  },
  {
    code: 4659,
    label: ':',
  },
  {
    code: 4660,
    label: '" (dead)',
  },
  {
    code: 4661,
    label: '~ (dead)',
  },
  {
    code: 4662,
    label: '<',
  },
  {
    code: 4663,
    label: '>',
  },
  {
    code: 4664,
    label: '?',
  },
  {
    code: 5124,
    label: 'Á',
  },
  {
    code: 5126,
    label: '©',
  },
  {
    code: 5127,
    label: 'Ð',
  },
  {
    code: 5128,
    label: 'É',
  },
  {
    code: 5132,
    label: 'Í',
  },
  {
    code: 5135,
    label: 'Ø',
  },
  {
    code: 5136,
    label: 'µ',
  },
  {
    code: 5137,
    label: 'Ñ',
  },
  {
    code: 5138,
    label: 'Ó',
  },
  {
    code: 5139,
    label: 'Ö',
  },
  {
    code: 5140,
    label: 'Ä',
  },
  {
    code: 5141,
    label: '®',
  },
  {
    code: 5142,
    label: 'ß',
  },
  {
    code: 5143,
    label: 'Þ',
  },
  {
    code: 5144,
    label: 'Ú',
  },
  {
    code: 5146,
    label: 'Å',
  },
  {
    code: 5148,
    label: 'Ü',
  },
  {
    code: 5149,
    label: 'Æ',
  },
  {
    code: 5150,
    label: '¡',
  },
  {
    code: 5151,
    label: '²',
  },
  {
    code: 5152,
    label: '³',
  },
  {
    code: 5153,
    label: '¤',
  },
  {
    code: 5154,
    label: '€',
  },
  {
    code: 5155,
    label: '¼',
  },
  {
    code: 5156,
    label: '½',
  },
  {
    code: 5157,
    label: '¾',
  },
  {
    code: 5158,
    label: '‘',
  },
  {
    code: 5159,
    label: '’',
  },
  {
    code: 5165,
    label: '¥',
  },
  {
    code: 5166,
    label: '×',
  },
  {
    code: 5167,
    label: '«',
  },
  {
    code: 5168,
    label: '»',
  },
  {
    code: 5169,
    label: '¬',
  },
  {
    code: 5171,
    label: '¶',
  },
  {
    code: 5172,
    label: '´',
  },
  {
    code: 5174,
    label: 'Ç',
  },
  {
    code: 5176,
    label: '¿',
  },
  {
    code: 5638,
    label: '¢',
  },
  {
    code: 5638,
    label: '¢',
  },
  {
    code: 5654,
    label: '§',
  },
  {
    code: 5654,
    label: '§',
  },
  {
    code: 5662,
    label: '¹',
  },
  {
    code: 5662,
    label: '¹',
  },
  {
    code: 5665,
    label: '£',
  },
  {
    code: 5665,
    label: '£',
  },
  {
    code: 5678,
    label: '÷',
  },
  {
    code: 5678,
    label: '÷',
  },
  {
    code: 5681,
    label: '¦',
  },
  {
    code: 5681,
    label: '¦',
  },
  {
    code: 5683,
    label: '°',
  },
  {
    code: 5683,
    label: '°',
  },
  {
    code: 5684,
    label: '¨',
  },
  {
    code: 5684,
    label: '¨',
  },
];
